import ListLayout from '../../../components/layout/main/ListLayout'
import { PageCard } from '../../../styles/CommonStyles'
import Tabbar from '../../../components/common/tabs/Tabbar'
import { useTabHook } from '../../../core/hooks/common/useTabHook'
import RecipientsList from '../../../components/main/reports/due-payments/recipients'
import VAsList from '../../../components/main/reports/due-payments/vas'
import FiatAccounts from '../../../components/main/reports/due-payments/accounts'

const TABS = ['vas', 'recipients', 'fiat-accounts']

const DooPayments = () => {
    const { tab, setTab } = useTabHook()

    const comps = [
        VAsList,
        RecipientsList,
        FiatAccounts
    ]
    const ActiveComp = comps[tab - 1]

    return (
        <ListLayout>
            <PageCard>
                <Tabbar active={tab} tabs={TABS} onTabClicked={setTab} />
                <ActiveComp />
            </PageCard>
        </ListLayout>
    )
}

export default DooPayments
